<template>
    <Head title="Profile" />
    <div class="mx-auto max-w-3xl pb-8" style="min-height: 50vh">
        <div class="px-4 sm:px-10 sm:text-center max-w-6xl md:mx-auto lg:text-left">
            <div>
                <Teaser :headlines="translate('teaser:headlines')" :subline="translate('teaser:subline')"></Teaser>
            </div>
        </div>
        <div class="mt-8">
            <div class="bg-white sm:w-full max-w-3xl sm:mx-auto sm:overflow-hidden">
                <div class="space-y-6">
                    <div class="bg-white shadow px-4 py-5 sm:rounded-lg sm:p-6">
                        <div class="md:grid md:grid-cols-3 gap-3">
                            <div class="md:col-span-1">
                                <h3 class="text-lg font-medium leading-6 text-gray-900">{{ translate('body:profileHeadline') }}</h3>
                            </div>
                            <div class="mt-5 md:mt-0 md:col-span-2">
                                <form action="#" method="POST" class="">
                                    <div class="grid grid-cols-6 gap-3">
                                        <div class="col-span-6">
                                            <label for="company" class="block text-sm font-medium text-gray-700">{{ translate('body:firstNameLabel') }}</label>
                                            <div class="relative">
                                                <input v-model="baseForm.firstName" id="fistName" name="name" type="text" :placeholder="translate('body:firstNamePlaceHolder')" class="appearance-none block w-full px-3 py-2 border border-gray-300 shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm" />
                                                <div class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none" v-if="baseForm.errors.firstName">
                                                    <ExclamationCircleIcon class="h-5 w-5 text-indigo-500" aria-hidden="true" />
                                                </div>
                                            </div>
                                            <p class="mt-2 text-sm text-red-600" id="firstBame-error" v-if="baseForm.errors.firstName">{{baseForm.errors.firstName}}</p>
                                        </div>
                                        <div class="col-span-6">
                                            <label for="company" class="block text-sm font-medium text-gray-700">{{ translate('body:lastNameLabel') }}</label>
                                            <div class="relative">
                                                <input v-model="baseForm.lastName" id="lastName" name="name" type="text" :placeholder="translate('body:lastNamePlaceHolder')" class="appearance-none block w-full px-3 py-2 border border-gray-300 shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm" />
                                                <div class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none" v-if="baseForm.errors.lastName">
                                                    <ExclamationCircleIcon class="h-5 w-5 text-indigo-500" aria-hidden="true" />
                                                </div>
                                            </div>
                                            <p class="mt-2 text-sm text-red-600" id="lastName-error" v-if="baseForm.errors.lastName">{{baseForm.errors.lastName}}</p>
                                        </div>
                                        <div class="sm:col-span-6">
                                            <label for="preferredLocale" class="block text-sm font-medium text-gray-700">{{ translate('body:localeLabel') }}</label>
                                            <div class="relative mt-1">
                                                <select v-model="baseForm.preferredLocale" id="preferredLocale" name="preferredLocale" required="" class="appearance-none block w-full px-3 py-2 border border-gray-300 shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm">
                                                    <option v-for="locale in formLocales" :key="locale.id" :value="locale.id">{{locale.label}}</option>
                                                </select>
                                            </div>
                                            <p class="mt-2 text-sm text-red-600" id="locale-error">{{baseForm.errors.preferredLocale}}</p>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="p-5 text-right">
                    <button @click="executeBase()" v-if="!submitting" type="button" class="inline-flex w-full justify-center border border-transparent bg-indigo-600 px-4 py-2 text-base font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:ml-3 sm:w-auto sm:text-sm">
                        {{ translate('body:submitButtonLabel') }}
                    </button>
                    <button v-if="submitting" type="button" class="inline-flex w-full justify-center border border-transparent px-4 py-2 text-base font-medium text-black shadow-sm sm:ml-3 sm:w-auto sm:text-sm">
                        {{ translate('body:submitButtonWaitLabel') }}
                    </button>
                </div>
            </div>
        </div>

        <div class="mt-8">
            <div class="bg-white sm:w-full max-w-3xl sm:mx-auto sm:overflow-hidden">
                <div class="space-y-6">
                    <div class="bg-white shadow px-4 py-5 sm:rounded-lg sm:p-6">
                        <div class="md:grid md:grid-cols-3 gap-3">
                            <div class="md:col-span-1">
                                <h3 class="text-lg font-medium leading-6 text-gray-900">{{ translate('body:emailHeadline') }}</h3>
                            </div>
                            <div class="mt-5 md:mt-0 md:col-span-2">
                                <form action="#" method="POST" class="">
                                    <div class="grid grid-cols-6 gap-3">
                                        <div class="sm:col-span-6">
                                            <label for="email" class="block text-sm font-medium text-gray-700">{{ translate('body:emailLabel') }}</label>
                                            <div class="relative mt-1">
                                                <input v-model="emailForm.email" id="email" name="email" type="email" :placeholder="translate('body:emailPlaceHolder')" required="" class="appearance-none block w-full px-3 py-2 border border-gray-300 shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm" />
                                                <div class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none" v-if="emailForm.errors.email">
                                                    <ExclamationCircleIcon class="h-5 w-5 text-indigo-500" aria-hidden="true" />
                                                </div>
                                            </div>
                                            <p class="mt-2 text-sm text-red-600" id="email-error">{{emailForm.errors.email}}</p>
                                            <p class="mt-2 text-sm text-gray-600" id="email-info" v-if="newEmail !== null">{{ translate('body:newEmail', {newEmail}) }}</p>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="p-5 text-right">
                    <button @click="executeEmail()" v-if="!submitting" type="button" class="inline-flex w-full justify-center border border-transparent bg-indigo-600 px-4 py-2 text-base font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:ml-3 sm:w-auto sm:text-sm">
                        {{ translate('body:submitEmailButtonLabel') }}
                    </button>
                    <button v-if="submitting" type="button" class="inline-flex w-full justify-center border border-transparent px-4 py-2 text-base font-medium text-black shadow-sm sm:ml-3 sm:w-auto sm:text-sm">
                        {{ translate('body:submitButtonWaitLabel') }}
                    </button>
                </div>
            </div>
        </div>

        <div class="mt-8">
            <div class="bg-white sm:w-full max-w-3xl sm:mx-auto sm:overflow-hidden">
                <div class="space-y-6">
                    <div class="bg-white shadow px-4 py-5 sm:rounded-lg sm:p-6">
                        <div class="md:grid md:grid-cols-3 gap-3">
                            <div class="md:col-span-1">
                                <h3 class="text-lg font-medium leading-6 text-gray-900">{{ translate('body:passwordHeadline') }}</h3>
                            </div>
                            <div class="mt-5 md:mt-0 md:col-span-2">
                                <form action="#" method="POST" class="">
                                    <div class="grid grid-cols-6 gap-3">
                                        <div class="sm:col-span-6">
                                            <label for="email" class="block text-sm font-medium text-gray-700">{{ translate('body:passwordLabel') }}</label>
                                            <div class="relative mt-1">
                                                <input v-model="passwordForm.password" id="password" name="password" type="password" :placeholder="translate('body:passwordPlaceHolder')" autocomplete="password" required="" class="appearance-none block w-full px-3 py-2 border border-gray-300 shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm" />
                                                <div class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none" v-if="passwordForm.errors.password">
                                                    <ExclamationCircleIcon class="h-5 w-5 text-indigo-500" aria-hidden="true" />
                                                </div>
                                            </div>
                                            <p class="mt-2 text-sm text-red-600" id="password-error">{{passwordForm.errors.password}}</p>
                                        </div>
                                        <div class="sm:col-span-6">
                                            <label for="email" class="block text-sm font-medium text-gray-700">{{ translate('body:passwordConfirmationLabel') }}</label>
                                            <div class="relative mt-1">
                                                <input v-model="passwordForm.password_confirmation" id="password_confirmation" name="password_confirmation" type="password" :placeholder="translate('body:passwordConfirmationPlaceHolder')" autocomplete="password" required="" class="appearance-none block w-full px-3 py-2 border border-gray-300 shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm" />
                                                <div class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none" v-if="passwordForm.errors.password_confirmation">
                                                    <ExclamationCircleIcon class="h-5 w-5 text-indigo-500" aria-hidden="true" />
                                                </div>
                                            </div>
                                            <p class="mt-2 text-sm text-red-600" id="password-confirmation-error">{{passwordForm.errors.password_confirmation}}</p>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="p-5 text-right">
                    <button @click="executePassword()" v-if="!submitting" type="button" class="inline-flex w-full justify-center border border-transparent bg-indigo-600 px-4 py-2 text-base font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:ml-3 sm:w-auto sm:text-sm">
                        {{ translate('body:submitPasswordButtonLabel') }}
                    </button>
                    <button v-if="submitting" type="button" class="inline-flex w-full justify-center border border-transparent px-4 py-2 text-base font-medium text-black shadow-sm sm:ml-3 sm:w-auto sm:text-sm">
                        {{ translate('body:submitButtonWaitLabel') }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {Head, useForm, usePage} from '@inertiajs/inertia-vue3'
import { Dialog, DialogPanel, DialogTitle, TransitionChild, TransitionRoot } from '@headlessui/vue'
import { ExclamationTriangleIcon, BanknotesIcon, CreditCardIcon } from '@heroicons/vue/24/outline'
import Teaser from "../../Components/Common/Teaser";
import translate from "../../../lang";
import {computed, ref} from 'vue'
import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/vue'
import { Link } from '@inertiajs/inertia-vue3'
import { EnvelopeIcon, PhoneIcon } from '@heroicons/vue/20/solid'
import { Listbox, ListboxButton, ListboxLabel, ListboxOption, ListboxOptions } from '@headlessui/vue'
import { CheckIcon, ChevronUpDownIcon } from '@heroicons/vue/20/solid'
import {
    FireIcon,
    CloudArrowUpIcon,
    PaperAirplaneIcon,
    ArchiveBoxIcon,
    ArrowRightCircleIcon,
    ChevronDownIcon,
    DocumentDuplicateIcon,
    HeartIcon,
    PencilIcon,
    TrashIcon,
    UserPlusIcon,
    ShareIcon,
    DocumentMagnifyingGlassIcon,
    ArrowUpRightIcon,
    XMarkIcon,
    EllipsisVerticalIcon
} from '@heroicons/vue/20/solid'
import {
    ArrowPathIcon,
    ClockIcon,
    LinkIcon
} from '@heroicons/vue/24/outline';
import {
    ExclamationCircleIcon
} from '@heroicons/vue/24/solid';

import {Inertia} from "@inertiajs/inertia";
import Burn from './Dialogs/Burn';
import Transfer from './Dialogs/Transfer';
import Recreate from './Dialogs/Recreate';
import DeleteUnfinished from "./Dialogs/DeleteUnfinished";
import MetaData from "./Dialogs/MetaData";
import DeleteBurned from "./Dialogs/DeleteBurned";
import Transactions from "./Dialogs/Transactions";
import Billing from "./Dialogs/Billing";
import LoadingDots from "./Components/LoadingDots";

export default {
    components: {
        Listbox, ListboxButton, ListboxLabel, ListboxOption, ListboxOptions,
        CheckIcon, ChevronUpDownIcon,
        ExclamationCircleIcon,
        XMarkIcon,
        CreditCardIcon,
        LoadingDots,
        BanknotesIcon,
        EllipsisVerticalIcon,
        DeleteUnfinished,
        Burn,
        Recreate,
        Transfer,
        MetaData,
        DeleteBurned,
        Transactions,
        Billing,
        CloudArrowUpIcon,
        LinkIcon,
        Teaser,
        Link,
        Head,
        Menu,
        MenuButton,
        MenuItem,
        MenuItems,
        ArchiveBoxIcon,
        ArrowRightCircleIcon,
        ChevronDownIcon,
        DocumentDuplicateIcon,
        HeartIcon,
        PencilIcon,
        TrashIcon,
        UserPlusIcon,
        PaperAirplaneIcon,
        DocumentMagnifyingGlassIcon,
        ArrowUpRightIcon,
        FireIcon,
        Dialog,
        DialogPanel,
        DialogTitle,
        TransitionChild,
        TransitionRoot,
        ExclamationTriangleIcon,
        ShareIcon,
        ArrowPathIcon,
        ClockIcon
    },
    props: {
        formLocales: Array
    },
    setup(props) {

        let user = usePage().props.value.auth.user;
        const baseForm = useForm({
            firstName: user.first_name,
            lastName: user.last_name,
            preferredLocale: user.locale,
        });
        const emailForm = useForm('profile_email', {
            email: user.email,
        });
        const passwordForm = useForm({
            password: null,
            password_confirmation: null,
        });
        const submitting = ref(false);
        function executeBase() {
            submitting.value = true;
            baseForm.post(route('profile_update_base_localized'), {
                preserveState: false,
                onFinish: () => {
                    submitting.value = false;
                },
            });
        }
        function executeEmail() {
            submitting.value = true;
            emailForm.post(route('profile_update_email_localized'), {
                preserveState: false,
                onFinish: () => {
                    submitting.value = false;
                },
            });
        }
        function executePassword() {
            submitting.value = true;
            passwordForm.post(route('profile_update_password_localized'), {
                preserveScroll: true,
                onFinish: () => {
                    submitting.value = false;
                },
            });
        }

        const newEmail = user.new_email;
        return {
            translate: translate('profile'),
            baseForm,
            emailForm,
            passwordForm,
            executeBase,
            executePassword,
            executeEmail,
            submitting,
            newEmail,
        };
    }
}
</script>
